import { LUDUM_ATTENDANCE_STATUSES, LUDUM_HEALTH_STATUSES } from '@/constants';
const { ATTENDING, NOT_ATTENDING } = LUDUM_ATTENDANCE_STATUSES;
const { ILL, INJURED } = LUDUM_HEALTH_STATUSES;
import get from 'get-object-path';

function toHealthBooleanMap(dataArray, allIds) {
    const map = {};
    allIds.forEach(id => { map[id] = false; });
    dataArray.forEach(({ id }) => { map[id] = true; });
    return map;
}

export const addResultsAttendance = {
    namespaced: true,

    state: {
        statuses: {},
        session: null,
        healthStatuses: [],
        missedAlternativeReasonOptions: []
    },

    getters: {
        statuses(state) {
            return state.statuses;
        },

        healthStatuses(state) {
            return state.healthStatuses;
        },

        missedAlternativeReasonOptions(state) {
            return state.missedAlternativeReasonOptions;
        },

        preparedHealthStatuses(state) {
            const users = {};
            Object.values(state.statuses).forEach(({ user_id, not_attending, health_statuses, did_alternative, missed_alternative_reason, user_event_note }) => {
                users[user_id] = {
                    attending: not_attending ? NOT_ATTENDING : ATTENDING,
                    health_statuses,
                    did_alternative,
                    missed_alternative_reason: missed_alternative_reason || null,
                    user_event_note: user_event_note || ''
                };
            });
            return users;
        }
    },

    mutations: {
        reset(state) {
            state.statuses = {};
            state.session = null;
        },

        setStatuses(state, session) {
            state.session = Object.assign({}, session);

            const participants = get(session, 'participants.data') || [];
            participants.forEach(participant => {
                Vue.set(state.statuses, participant.user_id, {
                    user_id: participant.user_id,
                    not_attending: get(participant, 'attendance.id') === NOT_ATTENDING,
                    health_statuses: {
                        [ILL]: toHealthBooleanMap(get(participant, 'health_statuses_ill.data') || [], state.healthStatuses.filter(s => s.health_type === ILL).map(s => s.id)),
                        [INJURED]: toHealthBooleanMap(get(participant, 'health_statuses_injured.data') || [], state.healthStatuses.filter(s => s.health_type === INJURED).map(s => s.id))
                    },
                    did_alternative: participant.did_alternative,
                    missed_alternative_reason: participant.missed_alternative_reason,
                    user_event_note: participant.user_event_note != null ? participant.user_event_note : ((state.statuses[participant.user_id] || {}).user_event_note || null)
                });
            });
        },

        setHealthStatuses(state, data) {
            state.healthStatuses = [...data];
        },

        addHealthStatus(state, status) {
            state.healthStatuses.push(status);
        },

        setMissedAlternativeReasonOptions(state, data) {
            state.missedAlternativeReasonOptions = [...data];
        }
    },

    actions: {
        resetSessionAttendance(context) {
            context.commit('setStatuses', context.state.session);
        },

        setSessionAttendance(context, payload) {
            return context.dispatch('saveSessionAttendance', {
                data: {
                    event_id: payload.session.id,
                    users: context.getters.preparedHealthStatuses
                }
            });
        },

        saveSessionAttendance(context, payload) {
            return context.dispatch(
                'post',
                {
                    url: `${api}session-attendance`,
                    data: payload.data
                },
                { root: true }
            );
        },

        fetchHealthStatuses(context) {
            return context.dispatch(
                'get',
                { url: api + 'health-type-names' },
                { root: true }
            ).then(response => {
                const illTypes = get(response, 'data.ill_types.data') || {};
                const injuredTypes = get(response, 'data.injured_types.data') || {};
                const illStatuses = Object.entries(illTypes).map(([id, name]) => ({ id: Number(id), name, health_type: ILL }));
                const injuredStatuses = Object.entries(injuredTypes).map(([id, name]) => ({ id: Number(id), name, health_type: INJURED }));
                context.commit('setHealthStatuses', [...illStatuses, ...injuredStatuses]);
            });
        }
    }
};

export default addResultsAttendance;
